import Group from 'entities/group'
import SideNavCollapseItem from 'components/side_nav/side_nav_collapse_item'
import SideNavItem from 'components/side_nav/side_nav_item'
import * as React from 'react'
import { FC } from 'react'
import {
  MdDashboard,
  MdEdit,
  MdEmail,
  MdFolderShared,
  MdGroup,
  MdGroupWork,
  MdInsertChart,
  MdViewList
} from 'react-icons/md'
import styles from './side_nav.module.scss'

type Props = {
  group: Group
  enableDashboard: boolean
  enableInvitations: boolean
  enableApplicants: boolean
  enableDirectIntroducitons: boolean
  enableInternalScouts: boolean
  enableOffers: boolean
  enableArticles: boolean
  enableGroups: boolean
  enableGroupCsvImport: boolean
  enableRecruiters: boolean
  enableRecruitersCsvImport: boolean
  enableUserNoticeMails: boolean
  enableUserNoticeRemoteNotifications: boolean
  enableEngagement: boolean
  enableReferralScores: boolean
}

const SideNav: FC<Props> = ({
  group,
  enableDashboard,
  enableInvitations,
  enableApplicants,
  enableDirectIntroducitons,
  enableInternalScouts,
  enableOffers,
  enableArticles,
  enableGroups,
  enableGroupCsvImport,
  enableRecruiters,
  enableRecruitersCsvImport,
  enableUserNoticeMails,
  enableUserNoticeRemoteNotifications,
  enableEngagement,
  enableReferralScores
}) => (
  <div className={styles.nav}>
    <div className={styles.navItems}>
      <SideNavItem
        enable={enableDashboard}
        icon={<MdDashboard size={20} />}
        path={Routes.dashboardPath()}
        title={I18n.t('components.side_nav.dashboard')}
      />
      <SideNavCollapseItem title={I18n.t('components.side_nav.entries')} icon={<MdViewList size={20} />}>
        <SideNavItem
          enable={enableInvitations}
          path={Routes.invitationsPath()}
          title={I18n.t('components.side_nav.invitation')}
        />
        <SideNavItem
          enable={enableApplicants}
          path={Routes.applicantsPath()}
          title={I18n.t('components.side_nav.applicant')}
        />
        <SideNavItem
          enable={enableDirectIntroducitons}
          path={Routes.directIntroductionsPath()}
          title={I18n.t('components.side_nav.direct_introduction')}
        />
        <SideNavItem
          enable={enableInternalScouts}
          path={Routes.internalScoutsPath()}
          title={I18n.t('components.side_nav.internal_scout')}
        />
      </SideNavCollapseItem>
      <SideNavItem
        enable={enableOffers}
        icon={<MdFolderShared size={20} />}
        path={Routes.offersPath()}
        title={I18n.t('components.side_nav.offer')}
      />
      <SideNavItem
        enable={enableArticles}
        icon={<MdEdit size={20} />}
        path={Routes.articlesPath()}
        title={I18n.t('components.side_nav.article')}
      />
      <SideNavCollapseItem title={I18n.t('components.side_nav.group.title')} icon={<MdGroupWork size={20} />}>
        <SideNavItem
          enable={enableGroups}
          icon={<MdGroupWork size={20} />}
          path={Routes.groupsPath()}
          title={I18n.t('components.side_nav.group.index')}
          only
        />
        <SideNavItem
          enable={enableGroupCsvImport}
          belongs={Routes.newGroupsCsvImportPath()}
          path={Routes.newGroupsCsvImportPath()}
          title={I18n.t('components.side_nav.group.csv_import')}
        />
      </SideNavCollapseItem>
      <SideNavCollapseItem title={I18n.t('components.side_nav.recruiter.title')} icon={<MdGroup size={20} />}>
        <SideNavItem
          enable={enableRecruiters}
          icon={<MdGroup size={20} />}
          path={Routes.recruitersPath()}
          title={I18n.t('components.side_nav.recruiter.index')}
          only
        />
        <SideNavItem
          enable={enableRecruitersCsvImport}
          belongs={Routes.newRecruitersCsvImportPath()}
          path={Routes.newRecruitersCsvImportPath()}
          title={I18n.t('components.side_nav.recruiter.csv_import')}
        />
      </SideNavCollapseItem>
      <SideNavCollapseItem title={I18n.t('components.side_nav.user_notice.title')} icon={<MdEmail size={20} />}>
        <SideNavItem
          enable={enableUserNoticeMails}
          belongs={Routes.userNoticeMailsPath()}
          path={Routes.newUserNoticeMailPath()}
          title={I18n.t('components.side_nav.user_notice.mail')}
        />
        <SideNavItem
          enable={enableUserNoticeRemoteNotifications}
          belongs={Routes.userNoticeRemoteNotificationsPath()}
          path={Routes.userNoticeRemoteNotificationsPath()}
          title={I18n.t('components.side_nav.user_notice.remote')}
        />
      </SideNavCollapseItem>
      <SideNavCollapseItem title={I18n.t('components.side_nav.survey.title')} icon={<MdInsertChart size={20} />}>
        <SideNavItem
          enable={enableEngagement}
          icon={<MdInsertChart size={20} />}
          path={Routes.engagementPath()}
          title={I18n.t('components.side_nav.survey.engagement')}
        />
        <SideNavItem
          enable={enableReferralScores}
          icon={<MdInsertChart size={20} />}
          path={Routes.referralScoresResultsShowPath(group.id)}
          title={I18n.t('components.side_nav.survey.referral_score')}
        />
      </SideNavCollapseItem>
    </div>
  </div>
)

export default SideNav
